import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BackResponse, BackResponseFailure } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.marketplace}files/${COMMON_QUERY_PARAMS.FILE_ID}/refunds`;

export interface RefundHistorySummary {
  amount: number;
  currencyCode?: string;
}

export interface RefundInfoResult {
  fileId: string;
  currencyCode?: string;
  productPrice: number;
  soldWarrantyPrice: number;
  shippingPrice: number;
  history?: RefundHistorySummary[];
  refunded: number;
  amountToRefund: number;
  amountToDeduct: number;
}

export interface GetRefundInfoRequestArgs {
  fileId: string;
}

export const getRefundInfoRequest = ({
  fileId,
}: GetRefundInfoRequestArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getRefundInfoQuery = async (
  payload: GetRefundInfoRequestArgs,
): Promise<BackResponse<RefundInfoResult> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<RefundInfoResult>>(
      getRefundInfoRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
